'use strict';

(function () {
  'use strict';

  angular.module('msSleep').controller('SleepPlanCtrl', SleepPlanCtrl);

  SleepPlanCtrl.$inject = ['$timeout', 'NotifyingSvc', 'sleepScheduleSvc'];

  function SleepPlanCtrl($timeout, NotifyingSvc, sleepScheduleSvc) {
    var vm = this;
    vm.schedule = {};
    vm.$onInit = function () {
      sleepScheduleSvc.getSchedule().then(function (schedule) {
        vm.schedule = schedule;
        if (vm.schedule.inBedTime && vm.schedule.inBedTime.length === 2) {
          vm.schedule.inBedTime.push(0);
        }
        if (vm.schedule.wakeUpTime && vm.schedule.wakeUpTime.length === 2) {
          vm.schedule.wakeUpTime.push(0);
        }
        $timeout(function () {
          return NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PRINT_HTTP_COMPLETE);
        });
      });
    };
  }
})();